import { useState, useEffect } from 'react'
import WalletIcon from 'material-ui/svg-icons/action/account-balance-wallet'
import Fetch from 'utils/fetch'
import DeleteBudget from 'components/delete-dialog'
import HeaderIcon from 'components/header-icon'
import BudgetList from './list'
import BudgetForm from './form'
import ButtonNewItem from 'components/button-new-item'
import intl from 'react-intl-universal'
import { formatErrorMessage } from 'utils/handle-error'
import { profileAdminOrMasterData } from "services/permissions/getPermissions"
import './budget.css'
import {  generateQueryParams } from 'utils/custom-functions'
import ButtonIcon from 'components/button-icon'
import { IconFilterActive } from 'components/icons/icn-filter-active.icon'
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon'
import Filter from 'components/filter'
import Sidebar from 'components/sidebar'
import { materialGroupFilterDefault, materialGroupSelectFilters, validateFilter } from '../utils'
import storePersist from 'utils/store-persist'
import { useBudgetFamilyContext } from '../context'

const Budget = () => {
  const { materialGroups, startFetching, stopFetching, handleShowFeedback } = useBudgetFamilyContext();
  const [budgets, setBudgets] = useState([])
  const [total, setTotal] = useState(0)
  const [openDelete, setOpenDelete] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const [openForm, setOpenForm] = useState(false)
  const [openEditMode, setOpenEditMode] = useState(false)
  const [idSelected, setIdSelected] = useState(0)
  const [showFilter, setShowFilter] = useState(false)
  const [filter, setFilter] = useState(() => storePersist.getValuesJSON('filtersMaterialGroup') ?? materialGroupFilterDefault);
  const [selectsFilters, setSelectsFilters] = useState(materialGroupSelectFilters());

  const proccessErro = (exception) => {
    stopFetching()
    handleShowFeedback(formatErrorMessage(exception))
  }

  const proccessData = (data) => {
    setBudgets(data.Data)
    setTotal(data.TotalItems)
  }

  const searchBudgets = (page = 0) => {
    startFetching();
    const _filter = { 
      ...filter,
      MaterialGroupId: filter.MaterialGroupId?.Id,
      _page: page
    };

    Fetch.get(`/material-groups:paginated?${generateQueryParams(_filter)}`)
      .then((response) => proccessData(response.data))
      .then(stopFetching)
      .then(() => setCurrentPage(page))
      .catch((e) => proccessErro(e))
  };

  const addFilterOptions = () => {
    setSelectsFilters(prev => prev.map(item => ({ ...item, options: materialGroups })));
  }

  const handleOpenForm = () => {
    setOpenForm(true)
  }

  const openNewForm = () => {
    setOpenEditMode(false)
    handleOpenForm()
  }

  const openEditForm = (row) => {
    const selected = budgets[row]
    setOpenEditMode(true)
    setIdSelected(selected.Id)
    handleOpenForm()
  }

  const closeForm = () => {
    setOpenForm(false)
  }

  const handleOpenDelete = (id) => {
    setOpenDelete(true)
    setIdSelected(id)
  }

  const closeDelete = () => {
    setOpenDelete(false)
  }

  const refreshSearch = () => {
    closeForm()
    searchBudgets(currentPage)
  }

  const deleteBudget = () => {
    Fetch.delete(`/carteira/${idSelected}`)
      .then(closeDelete)
      .then(() => searchBudgets(currentPage))
      .then(() => handleShowFeedback(intl.get('master-data.walletsAndFamilys.wallets.deleteModalWallet.walletSuccessfullyDeleted')))
      .catch((e) => proccessErro(e))
  };

  const handleShowFilter = () => {
    setShowFilter(prev => !prev)
  };

  const handleClearFilter = () => {
    storePersist.setValuesJSON("filtersMaterialGroup", materialGroupFilterDefault);
    setFilter(materialGroupFilterDefault);
    handleShowFilter();
  };

  const handleSearchFilter = (filter) => {
    storePersist.setValuesJSON("filtersMaterialGroup", filter);
    setFilter(filter);
    handleShowFilter();
  }

  useEffect(() => {
    searchBudgets();
  }, [filter]);

  useEffect(() => {
    if(materialGroups.length > 0) addFilterOptions();
  }, [materialGroups])

  return (
    <div className='budget-container'>
      <div className="budget-header">
        <HeaderIcon
          title={intl.get('master-data.walletsAndFamilys.wallets.header.title')}
          subtitle={intl.get('master-data.walletsAndFamilys.wallets.header.subtitle')}
          icon={<WalletIcon style={{ width: 45, height: 45 }} color='var(--color-brand-500)' />}
        >
          {profileAdminOrMasterData() &&
            <div title={intl.get('master-data.walletsAndFamilys.wallets.actions.newWallet')}>
              <ButtonNewItem
                className="general-button"
                onClick={openNewForm}
              />
            </div>
          }
          <div title={intl.get('master-data.walletsAndFamilys.wallets.actions.filter')} className='filterContainer'>
            <ButtonIcon
              onClick={handleShowFilter}
              buttonType='default'
              buttonText={intl.get('filters.filter')}
              buttonIcon={validateFilter(filter) ? <IconFilterActive /> : <IconFilterInactive />}
              className={"button-filter"}
            />
          </div>
        </HeaderIcon>
      </div>
      <BudgetList
        data={budgets}
        countData={total}
        refreshSearch={searchBudgets}
        handleEdit={openEditForm}
        handleDelete={handleOpenDelete}
        qtRegsPerPage={filter._size}
        profileAdminOrMasterData={profileAdminOrMasterData()}
      />

      {openForm &&
        <BudgetForm
          idEdit={idSelected}
          open={openForm}
          editMode={openEditMode}
          handleClose={closeForm}
          handleRefresh={refreshSearch}
          handleFeedback={handleShowFeedback}
          profileAdminOrMasterData={profileAdminOrMasterData()}
        />
      }

      <DeleteBudget
        open={openDelete}
        title={intl.get('master-data.walletsAndFamilys.wallets.deleteModalWallet.title')}
        handleClose={closeDelete}
        warningMessage={intl.get('master-data.general.materials.description')}
        handleConfirm={deleteBudget}
      />

      <Sidebar visible={showFilter} triggerClose={handleShowFilter} style={{ padding: '10px 20px 0'}} >
        <Filter
          handleSearch={handleSearchFilter}
          handleClear={handleClearFilter}
          selectsFilters={selectsFilters}
          filtersDefault={filter}
        />
      </Sidebar>
    </div>
  )
}

export default Budget
